// IKM Product Form AJAX handler
// Intercepts add-to-cart on marked product forms and opens the IKM cart drawer.

(function () {
  'use strict';

  function initIkmProductForms() {
    var productForms = document.querySelectorAll('product-form[data-ikm-cart-drawer="true"]');
    if (!productForms.length) return;

    productForms.forEach(function (productFormEl) {
      var form = productFormEl.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      // Avoid binding twice
      if (form.dataset.ikmProductFormBound === 'true') return;
      form.dataset.ikmProductFormBound = 'true';

      form.addEventListener('submit', function (event) {
        // Stop normal navigation to /cart
        event.preventDefault();
        event.stopImmediatePropagation();

        var submitButton = form.querySelector('button[type="submit"][name="add"], .product-form__submit');
        if (submitButton) {
          submitButton.disabled = true;
        }

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Add to cart failed with status ' + response.status);
            }
            return response.json();
          })
          .then(function (addedItem) {
            // Fetch full cart to keep drawer/header in sync
            return fetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) {
                if (!r.ok) throw new Error('Failed to fetch cart state');
                return r.json();
              })
              .then(function (cart) {
                // Update global first product id used by ikm-cart-drawer.js
                if (cart.items && cart.items.length > 0) {
                  window.IKM_CART_FIRST_PRODUCT_ID = cart.items[0].product_id;
                } else {
                  window.IKM_CART_FIRST_PRODUCT_ID = null;
                }

                // Notify IKM cart drawer listeners
                document.dispatchEvent(
                  new CustomEvent('ikm:cart:updated', {
                    detail: { cart: cart },
                  })
                );
                document.dispatchEvent(
                  new CustomEvent('ikm:cart:added', {
                    detail: { cart: cart, item: addedItem },
                  })
                );
              });
          })
          .catch(function (error) {
            console.error('[IKM Product Form] Add to cart error:', error);
            // Fallback to standard cart page if AJAX fails
            window.location.href = '/cart';
          })
          .finally(function () {
            if (submitButton) {
              submitButton.disabled = false;
            }
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIkmProductForms);
  } else {
    initIkmProductForms();
  }
})();

